export default from './QuizPage';



// WEBPACK FOOTER //
// ./src/components/QuizPage/index.js